import { render, staticRenderFns } from "./LowNews.vue?vue&type=template&id=46fa254e&scoped=true"
import script from "./LowNews.vue?vue&type=script&lang=js"
export * from "./LowNews.vue?vue&type=script&lang=js"
import style0 from "./LowNews.vue?vue&type=style&index=0&id=46fa254e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa254e",
  null
  
)

export default component.exports